module.exports = __webpack_public_path__ + "img/information-icon-blue.831e5a17.svg";